<!-- 안전리더십 > 과제설정 > 퀴즈형식설정 팝업 -->
<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="94rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{t('message.quizFormatSetting')}}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>

        <!--content-->
        <div class="pop-cont">
          <div class="form-group col-ty sty1">
            <!--form-row-->
            <div class="form-row ty06">
              <div class="txt-tit ty04">{{t('message.type')}}</div>
              <div class="row">
                <div class="txt">{{t('message.quizFormat')}}</div>
                <div class="txt">{{t('message.overall')}} {{quizData.questionList?quizData.questionList.length:0}}{{t('message.count')}}</div>
              </div>
            </div>
          </div>
        </div>
        <v-card-text>
          <div class="form-box"
               v-for="(item, i) in quizData.questionList"
               :key="i">
            <div class="form-group col-ty">
              <BtnIcon class="btn-ico-delete02" @click="onClickDelete(item)"></BtnIcon>
              <!--form-row-->
              <div class="form-row">
                <div class="txt-tit ty05">{{t('message.title')}}<span class="imp">*</span></div>
                <div class="row">
                  <c-Input :placeholder="t('message.enterTitle')" class="size04" :name="'questionTitle'+i" v-model="item.questionTitle"/>
                </div>
              </div>
              <!--form-row-->
              <div class="form-row">
                <div class="txt-tit ty05">{{t('message.itemsPerPage')}}</div>
                <div class="row">
                  <Select v-bind="answerCntSelect" v-model="item.exampleCnt" @update:modelValue="(value) => onChangeAnswerCnt(value, item)"/>
                  <div class="row-dv"
                       v-for="(item2, i2) in item.exampleList"
                       :key="i2"
                  >
                    <c-Input :placeholder="t('message.enterChoices')" class="size04" :name="'exampleTitle'+'_'+i+'_'+i2" v-model="item2.exampleTitle"/>
                    <div class="col-dv">
                      <div class="check-group">
                        <v-checkbox v-model="item.answerSeq" :true-value="i2+1" false-value="0" :label="t('message.correctAnswer')" ></v-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <!--버튼-->
        <div class="pop-cont03">
          <c-btnLine01 :btnText="t('message.addNew')" class="ty02" @click="onClickAdd"/>
        </div>
        <v-card-actions class=" d-flex justify-end">
          <c-btn02 :btnText="t('message.cancel')" @click="dialog=false"/>
          <c-btn01 :btnText="t('message.save')" @click="onClickSave"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import {useForm} from "vee-validate";
import LeadershipService from "@/services/leadership.service";
import utils from "@/common/Utils";
import * as yup from "yup";
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//validation schema
const schema = yup.object().shape({
  title: yup.string().required(() => t('message.requiredField')),
})
const { validate } = useForm({ validationSchema: schema })

//bind
const snackbar = ref(false)
const snackText = ref('')
const quizData:any = ref({})

//ui
const answerCntSelect = {items: [{name: '2', value: 2}, {name: '3', value: 3}, {name: '4', value: 4}, {name: '5', value: 5}]}

//hook
onUpdated (() => {
  if (dialog.value) {
    quizData.value = {}
    getQuiz()
  }
})

const getQuiz = async ()=>{
  try {
    let popupItems:any = storeRef.selectedContent.value
    const response = await LeadershipService.getQuiz({contentIdx: popupItems.idx})
    quizData.value = response.result
    _.forEach(quizData.value.questionList, (question)=>{
      question.exampleCnt = question.exampleList?question.exampleList.length:0
    })
  }
  catch (error) {
    if(error.status == 403)
      utils.movePage('/login')
    else
      utils.log(error)
  }
}

const onClickSave = async ()=>{
  try{
    let popupItems = storeRef.selectedContent.value
    const response = await LeadershipService.insertQuiz(quizData.value)
    if(response.success)
      dialog.value = false
  }
  catch (error) {
    if(error.status == 403)
      utils.movePage('/login')
    else
      utils.log(error)
  }
}

const onClickAdd = ()=>{
  let popupItems:any = storeRef.selectedContent.value
  if(utils.isEmpty(quizData.value.questionList))
    quizData.value.questionList = []
  let quizCnt = quizData.value.questionList.length
  let newRow = {
    leadershipIdx:popupItems.leadershipIdx,
    taskIdx:popupItems.taskIdx,
    contentIdx:popupItems.idx,
    quizIdx:quizData.value.idx,
    questionTitle:'',
    showOrder:quizCnt+1,
    exampleCnt:2,
    answerSeq:1,
    exampleList:[
      {
        leadershipIdx:popupItems.leadershipIdx,
        taskIdx:popupItems.taskIdx,
        contentIdx:popupItems.idx,
        questionIdx:0,
        exampleTitle:'',
        showOrder:1
      },
      {
        leadershipIdx:popupItems.leadershipIdx,
        taskIdx:popupItems.taskIdx,
        contentIdx:popupItems.idx,
        questionIdx:0,
        exampleTitle:'',
        showOrder:2
      }
    ]
  }
  quizData.value.questionList.push(newRow)
}

const onChangeAnswerCnt = (value, item)=>{
  if(item.exampleList.length > value){
    item.exampleList = _.slice(item.exampleList, 0, value)
  }
  else if(item.exampleList.length < value){
    let curCnt = item.exampleList.length
    for(let i = curCnt+1; i <= value; i++){
      item.exampleList.push(
        {
          leadershipIdx:item.leadershipIdx,
          taskIdx:item.taskIdx,
          contentIdx:item.contentIdx,
          quizIdx:item.quizIdx,
          exampleTitle:'',
          showOrder:i
        }
      )
    }
  }
}

const onClickDelete = (value)=>{
  _.remove(quizData.value.questionList, value)
}
</script>


<style lang="scss" scoped>
.sortable-group02{
  .sortable-header ,.sortable-cont .draggable{
    .col:nth-child(1){flex-grow:0;width:5%;}
    .col:nth-child(2){justify-content:flex-start;text-align:left}
    .col:nth-child(3){flex-grow:0;width:6%;}
    .col:nth-child(4){flex-grow:0;width:6%;}
    .col:nth-child(5){flex-grow:0;width:12%;}
    .col:nth-child(6){flex-grow:0;width:12%;}
    .col:nth-child(7){flex-grow:0;width:8%;}
    .col:nth-child(8){flex-grow:0;width:6%;}
    .col:nth-child(9){flex-grow:0;width:6%;}
    .col:nth-child(10){flex-grow:0;width:6%;}
    .col:nth-child(11){flex-grow:0;width:5%;}
    .col:nth-child(12){flex-grow:0;width:5%;}
  }
  .sortable-footer{
    .col:nth-child(1){flex-grow:0;width:16%;}
    .col:nth-child(2){flex-grow:0;width:38%;}
  }
}
</style>
